import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DialogComponent } from '../contact/dialog.component';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  registerForm: FormGroup;
  submitted = false;
  closeResult: string;
  //SERVER_URL = 'http://localhost/Mail/contact.php';
  //SERVER_URL = 'http://localhost:8081/Mail/contact.php';
  SERVER_URL = 'https://www.oriolbassols.es/mail/contact.php';

  constructor(private formBuilder: FormBuilder, private httpClient: HttpClient, public dialog: MatDialog) { }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      subject: ['', Validators.required],
      name: ['', Validators.required],
      message: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]]
    });
  }

     // convenience getter for easy access to form fields
     get f() { return this.registerForm.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.registerForm.invalid) {
        return;
    }
    const formData = new FormData();
    formData.append('subject', this.registerForm.get('subject').value);
    formData.append('name', this.registerForm.get('name').value);
    formData.append('email', this.registerForm.get('email').value);
    formData.append('message', this.registerForm.get('message').value);

    this.httpClient.post<any>(this.SERVER_URL, formData).subscribe(
      (res) => console.log(res),
      (err) => console.log(err)
    );

    // display form values on success
    // alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.registerForm.value, null, 4));
    //alert('Your Message has correctly been send.');
    this.showDialog();
    this.onReset();
}
  onReset() {
    this.submitted = false;
    this.registerForm.reset();
  }
  showDialog():void{
    let dialogRef = this.dialog.open(DialogComponent, {
      
    }); 
    setTimeout(() => {
      dialogRef.close();
    }, 10000);
  }
}